
import bgImage from '../../../../asset/images/europe.png';
export function HeroSection() {
  return (
    <section className="relative min-h-screen bg-cover bg-center bg-no-repeat" 
             style={{
               backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${bgImage})`
             }}>
      <div className="absolute inset-0 bg-black bg-opacity-40"></div>
      <div className="relative z-10 container mx-auto px-6 py-32 lg:py-40">
        <div className="max-w-4xl">
          <h1 className="text-5xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            UK Regional
          </h1>
          <div className="prose prose-lg text-white max-w-none">
            <p className="text-lg leading-relaxed mb-6">
              Discover United Kingdom with PrimeMeridian, your go-to for exceptional travel services. Explore, indulge, and experience the English charm seamlessly.
            </p>
            <p className="text-lg leading-relaxed mb-6">
              A single sovereign state comprising the four countries of England, Scotland, Wales and Northern Ireland, the United Kingdom packs a wealth of history, culture and scenery into a surface area only slightly larger than the state of Minnesota. Our specialists have journeyed extensively around Great Britain and Northern Ireland, gathering ideas for how you can visit and combine the UK’s highlights for your vacation.
            </p>
             <button className="inline-flex items-center px-6 py-3 bg-emerald-600 text-white font-medium rounded-lg hover:bg-emerald-700 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                  Explore SIghtseeing
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center ml-2"></i>
             </button>
          </div>
        </div>
        <div className="max-w-4xl">
          <h1 className="text-5xl lg:text-7xl font-bold text-white mb-6 mt-8 leading-tight">
           Europe Regional
          </h1>
          <div className="prose prose-lg text-white max-w-none">
            <p className="text-lg leading-relaxed mb-6">
              Uncover the diverse charm of Europe through its regional discoveries — from the romantic streets of Paris and the cultural pulse of Rome to the alpine beauty of Switzerland and the fairytale villages of Central Europe. Each region offers a unique blend of history, cuisine, art, and natural landscapes, inviting travelers to experience Europe beyond the usual routes.
            </p>
            <button className="inline-flex items-center px-6 py-3 bg-emerald-600 text-white font-medium rounded-lg hover:bg-emerald-700 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                  Explore SIghtseeing
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center ml-2"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
